import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { PeliculaHorario } from '../models/pelicula-horario';
@Injectable({
  providedIn: 'root'
})
export class PeliculaHorarioService {


  constructor(private http: HttpClient) { }
  //
  // private programacionHorarios: PeliculaHorario[];
  // private programacionHorarios$ = new Subject<PeliculaHorario[]>();
  //
  // private programacionHorario: PeliculaHorario;
  // private programacionHorario$ = new Subject<PeliculaHorario>();
  //
  // change(val) {
  //   this.programacionHorarios = val;
  //   this.programacionHorarios$.next(this.programacionHorarios);
  // }
  // get$(): Observable<PeliculaHorario[]> {
  //   return this.programacionHorarios$.asObservable();
  // }
  //
  // changeOne(val) {
  //   this.programacionHorario = val;
  //   this.programacionHorario$.next(this.programacionHorario);
  // }
  // getOne$(): Observable<PeliculaHorario> {
  //   return this.programacionHorario$.asObservable();
  // }


  getTipo() {
    return this.http.get(environment.apiUrl + 'programacionHorario/getTipo')
      .pipe(map((res: any) => {
        return res;
      }));
  }
  getEspacio() {
    return this.http.get(environment.apiUrl + 'programacionHorario/getEspacio')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getAll(): Observable<PeliculaHorario[]> {
    return this.http.get(environment.apiUrl + 'programacionHorario')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getFilter(data): Observable<PeliculaHorario[]> {

    return this.http.post(environment.apiUrl + 'programacionHorario/getFilter', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }


  get(id) {
    return this.http.get(environment.apiUrl + 'programacionHorario/' + id)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  add(data) {
    return this.http.post(environment.apiUrl + 'programacionHorario', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
  edit(data) {
    const apiUrl = environment.apiUrl + 'programacionHorario';
    const url = `${apiUrl}/${data["id"]}`;


    return this.http.put(url, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  delete(id) {

    return this.http.delete(environment.apiUrl + 'programacionHorario/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }


}
